
const hash = state => state.hash
const status = state => state.status

export default {
  hash,
  status
}
